// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_9u-0";
export var optionCard = "_9u-1";